
import './App.css';
import GameBoard from "./components/GameBoard"

function App() {
  return (
    <div>
      <GameBoard></GameBoard>
    </div>
  );
}

export default App;
